import { iso } from 'newtype-ts';
import { hasProp } from '../../hasProp';
const _ = iso();
export const construct = (c) => _.wrap({ ...c, tag: 'null-product' });
export const is = (u) => {
    if (typeof u === 'object' && u !== null && hasProp(u, 'tag')) {
        return u.tag === 'null-product';
    }
    return false;
};
